/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import axios from 'axios';
import toastr from 'toastr';
import Escalate from '../../../shared/escalate/Escalate';
import ProcurementNavBar from '../../../../layouts/procurement/ProcurementNavBar';
import { PROCUREMENT, API_URL } from '../../../../../utils/config';
import SuperAdminHeader from '../../../../layouts/super-admin/SuperAdminHeader';
import { SUPER_ADMIN } from '../../../../../utils/departments/helpers';

class ProcurementEscalate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      role: '',
    };
  }

  getUserDetails() {
    axios({
      method: 'get',
      url: `${API_URL}/employee/loggedOnEmployee`,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    }).then((res) => {
      if (res.data) {
        this.setState({
          firstName: res.data.firstName,
        });
      }
    });
  }

  fetchLoggedOnUser() {
    axios({
      method: 'get',
      url: `${API_URL}/employeeReg/logged`,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
      json: true,
    })
      .then((response) => {
        this.setState({
          role: response.data.role_id,
        });
        if (response.data.id) {
          if (response.data.department_id !== `${PROCUREMENT}` && response.data.department_id !== `${SUPER_ADMIN}`) {
            this.props.history.push('/staff/login');
            toastr.info('You are not allowed to view this page');
          }
        }
      })
      .catch((err) => {});
  }

  render() {
    const { firstName, role } = this.state;

    return (
      <div className="s-layout">
        <main className="s-layout__content col-lg-10 p-0">
          <ProcurementNavBar currentPage="Escalate" position={firstName} role_id={role} />

          <div className="container">
            <div className="row mt-5">
              <div className="col-lg-12 col-md-12 col-sm-12 mb-3 mt-4">
                <Escalate dept={firstName} />
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default ProcurementEscalate;
